import {ListContractSortableField, SortableField} from "../models/SortableFieldEnum";
import {contractTypeMap} from "../../../../model/enum-contractTypes";
import * as React from "react";
import {ListContract, Milestone} from "../ContractlistState";

interface Props {
    field: SortableField;
    contract: ListContract;
}

export const ContractValueCell = ({field, contract}: Props) => {

    let value;
    switch (field.name) {
        case ListContractSortableField.milestones:
            const milestone = contract.milestones[0] as Milestone;
            if (milestone) {
                const milestoneDate = new Date(milestone.deadline);
                const now = Date.now();
                const oneWeekAhead = new Date(now + 7 * 86400000);

                let status = milestoneDate.getTime() < now ? "critical" : milestoneDate.getTime() < oneWeekAhead.getTime() ? "imminent": "";

                value = (<span className={"milestone " + (status)}>{milestoneDate.toLocaleDateString("nb")}: {milestone.name}</span>);
            } else
            value = null;
            break;
        case ListContractSortableField.lastModified:
        case ListContractSortableField.completionDate:
            value = <span>{((contract as any)[field.value] ? new Date((contract as any)[field.value]).toLocaleDateString("nb") : "")}</span>;
            break;
        case ListContractSortableField.contractType:
            value = <span>{contractTypeMap[contract.contractType]}</span>;
            break;
        case  ListContractSortableField.rowActions:
            value = <span>""</span>;
            break;
        case  ListContractSortableField.name:
            let changeIndicator = contract.hasChanges ? (<span className={"hasChangeBadge"} title={"Kontrakten har endringer siden sist"}/>) : null;
            value = <span>{changeIndicator} <a href={`#!/contract/${contract.id}`} className="link-nostyle">{contract.name}</a></span>;
            break;
        default:
            value = <span>{(contract as any)[field.value]}</span>;
    }

    return (
        <td key={field.name}>{value}</td>
    );
}

